<template>
  <ContentWrap>
    <el-form ref="queryFormRef" :inline="true" :model="queryParams">
      <el-form-item label="用户昵称" prop="nickname">
        <el-input
          v-model="queryParams.nickname"
          clearable
          placeholder="请输入用户昵称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="联系电话" prop="mobile">
        <el-input
          v-model="queryParams.mobile"
          clearable
          placeholder="请输入联系电话"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker
          v-model="queryParams.createTime"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">搜索</el-button>
        <el-button @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="头像" width="80" align="center">
        <template #default="scope">
          <el-avatar :size="40" :src="scope.row.avatar" />
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="用户昵称" min-width="130" show-overflow-tooltip />
      <el-table-column prop="contactMobile" label="联系电话" width="130" />
      <el-table-column prop="company" label="公司" min-width="150" show-overflow-tooltip />
      <el-table-column prop="position" label="职位" min-width="120" show-overflow-tooltip />
      <el-table-column prop="industry" label="行业" min-width="120" show-overflow-tooltip />
      <el-table-column label="状态" width="90" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
            {{ scope.row.status === 0 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" :formatter="dateFormatter" />
      <el-table-column label="操作" width="260" fixed="right">
        <template #default="scope">
          <el-button
            v-hasPermi="['bosscircle:user:update']"
            link
            type="primary"
            @click="openEdit(scope.row.id)"
            >编辑</el-button
          >
          <el-button link type="primary" @click="openDetail(scope.row.id)">详情</el-button>
          <el-button
            v-hasPermi="['bosscircle:user:update']"
            link
            :type="scope.row.status === 0 ? 'warning' : 'success'"
            @click="handleStatus(scope.row)"
            >{{ scope.row.status === 0 ? '禁用' : '启用' }}</el-button
          >
          <el-button
            v-hasPermi="['bosscircle:user:update']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="queryParams.pageNo"
      v-model:limit="queryParams.pageSize"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="editVisible" title="编辑用户" width="720px">
    <el-form ref="editFormRef" :model="form" :rules="formRules" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12"
          ><el-form-item label="用户昵称" prop="nickname"
            ><el-input v-model="form.nickname" maxlength="30" /></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="头像" prop="avatar"
            ><UploadImg v-model="form.avatar" /></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="行业" prop="industry"
            ><el-input v-model="form.industry" maxlength="100" /></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="职位" prop="position"
            ><el-input v-model="form.position" maxlength="100" /></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="公司" prop="company"
            ><el-input v-model="form.company" maxlength="200" /></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="联系电话" prop="mobile"
            ><el-input
              v-model="form.mobile"
              maxlength="32"
              :placeholder="`为空时使用 ${form.memberMobile || '会员手机号'}`" /></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="联系邮箱" prop="email"
            ><el-input
              v-model="form.email"
              maxlength="128"
              :placeholder="`为空时使用 ${form.memberEmail || '会员邮箱'}`" /></el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="网站" prop="website"
            ><el-input v-model="form.website" maxlength="255" /></el-form-item
        ></el-col>
        <el-col :span="24"
          ><el-form-item label="个人标签" prop="tags"
            ><el-input
              v-model="form.tags"
              maxlength="500"
              :placeholder="tagsPlaceholder" /></el-form-item
        ></el-col>
        <el-col :span="24"
          ><el-form-item label="个人简介" prop="intro"
            ><el-input
              v-model="form.intro"
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit /></el-form-item
        ></el-col>
        <el-col :span="24"
          ><el-form-item label="主页背景图" prop="backgroundImg"
            ><UploadImg v-model="form.backgroundImg" /></el-form-item
        ></el-col>
        <el-col :span="24"
          ><el-form-item label="联系地址" prop="address"
            ><el-input v-model="form.address" maxlength="500" /></el-form-item
        ></el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button @click="editVisible = false">取消</el-button>
      <el-button type="primary" :loading="saving" @click="submitEdit">保存</el-button>
    </template>
  </Dialog>

  <Dialog v-model="detailVisible" title="用户详情" width="720px">
    <el-descriptions v-if="detail" :column="2" border>
      <el-descriptions-item label="头像"
        ><el-avatar :size="48" :src="detail.avatar"
      /></el-descriptions-item>
      <el-descriptions-item label="用户昵称">{{ detail.nickname || '-' }}</el-descriptions-item>
      <el-descriptions-item label="联系电话">{{
        detail.contactMobile || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="联系邮箱">{{
        detail.email || detail.memberEmail || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="公司">{{ detail.company || '-' }}</el-descriptions-item>
      <el-descriptions-item label="职位">{{ detail.position || '-' }}</el-descriptions-item>
      <el-descriptions-item label="行业">{{ detail.industry || '-' }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{
        detail.status === 0 ? '启用' : '禁用'
      }}</el-descriptions-item>
      <el-descriptions-item label="个人标签" :span="2">{{
        detail.tags || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="个人简介" :span="2">{{
        detail.intro || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="网站" :span="2">{{
        detail.website || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="联系地址" :span="2">{{
        detail.address || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="创建时间" :span="2">{{
        formatDate(detail.createTime)
      }}</el-descriptions-item>
    </el-descriptions>
  </Dialog>
</template>

<script setup lang="ts">
import type { FormInstance, FormRules } from 'element-plus'
import { dateFormatter, formatDate } from '@/utils/formatTime'
import * as Api from '@/api/business/user'

defineOptions({ name: 'BossCircleUser' })

const message = useMessage()
const tagsPlaceholder = 'JSON 数组，如 ["创业者","投资人"]'
const loading = ref(false)
const saving = ref(false)
const list = ref<Api.BusinessUser[]>([])
const total = ref(0)
const editVisible = ref(false)
const detailVisible = ref(false)
const detail = ref<Api.BusinessUser>()
const queryFormRef = ref<FormInstance>()
const editFormRef = ref<FormInstance>()
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  nickname: '',
  mobile: '',
  createTime: [] as string[]
})
const form = reactive<Partial<Api.BusinessUser>>({})
const formRules: FormRules = {
  nickname: [{ required: true, message: '请输入用户昵称', trigger: 'blur' }],
  email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }]
}

const getList = async () => {
  loading.value = true
  try {
    const data = await Api.getUserPage(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value?.resetFields()
  handleQuery()
}

const openEdit = async (id: number) => {
  Object.assign(form, await Api.getUser(id))
  editVisible.value = true
  await nextTick()
  editFormRef.value?.clearValidate()
}

const submitEdit = async () => {
  if (!(await editFormRef.value?.validate().catch(() => false))) return
  saving.value = true
  try {
    await Api.updateUser(form)
    message.success('保存成功')
    editVisible.value = false
    await getList()
  } finally {
    saving.value = false
  }
}

const openDetail = async (id: number) => {
  detail.value = await Api.getUser(id)
  detailVisible.value = true
}

const handleStatus = async (row: Api.BusinessUser) => {
  const status = row.status === 0 ? 1 : 0
  await message.confirm(`确认${status === 0 ? '启用' : '禁用'}该用户吗？`)
  await Api.updateUserStatus(row.userId, status)
  message.success('操作成功')
  await getList()
}

const handleDelete = async (id: number) => {
  await message.delConfirm()
  await Api.deleteUser(id)
  message.success('删除成功')
  await getList()
}

onMounted(getList)
</script>
